var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaHospitalO007E8D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007e8d",
    d: "M448 492v20H0v-20c0-6.6 5.4-12 12-12h20V120c0-13.3 10.7-24 24-24h88V24c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v72h88c13.3 0 24 10.7 24 24v360h20c6.6 0 12 5.4 12 12zM308 192h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm-168 64h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm104 128h-40c-6.6 0-12 5.4-12 12v84h64v-84c0-6.6-5.4-12-12-12zm64-96h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm-116 12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0 -6-6h-26V38a6 6 0 0 0 -6-6h-20a6 6 0 0 0 -6 6v26h-26a6 6 0 0 0 -6 6v20a6 6 0 0 0 6 6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaHospitalO007E8D);
export default __webpack_public_path__ + "static/media/fa-hospital-o-007E8D.c7814e36464102693d20bfc46abcd0b2.svg";
export { ForwardRef as ReactComponent };